// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../Assets/images/vendorbg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ourvendors_vendorCards__OtKP3 {
  display: flex;
  gap: 10px;
}
.ourvendors_vendorCards__OtKP3 .ourvendors_vendorCard__AluKS {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  width: 360px;
  height: 200px;
  padding: 20px 0;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 20px;
}
.ourvendors_vendorCards__OtKP3 .ourvendors_vendorCard__AluKS .ourvendors_cashback__i57ZA {
  width: 95%;
  height: 36px;
  background: rgb(255, 255, 255);
  border-radius: 14px 14px 4px 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
}
.ourvendors_vendorCards__OtKP3 .ourvendors_vendorCard__AluKS .ourvendors_cashback__i57ZA .ourvendors_africamap__SJan6 {
  background: linear-gradient(310.98deg, #03297F 9.74%, #1656AF 90.51%);
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
}

.ourvendors_vendorDetails__XsoKe {
  width: 600px;
}
.ourvendors_vendorDetails__XsoKe header {
  display: flex;
  flex-direction: column;
  min-height: 300px;
}
.ourvendors_vendorDetails__XsoKe header .ourvendors_header__bjlKW {
  min-width: 100%;
  min-height: 200px;
  background-color: red;
  position: relative;
}
.ourvendors_vendorDetails__XsoKe header .ourvendors_header__bjlKW .ourvendors_bgimg__\\+Gsa\\+ {
  width: 100%;
  height: 100%;
}
.ourvendors_vendorDetails__XsoKe header .ourvendors_header__bjlKW .ourvendors_vendorIcon__c0RCp {
  position: absolute;
  width: 96.64px;
  height: 96.64px;
  bottom: -70px;
  left: 30px;
}
.ourvendors_vendorDetails__XsoKe header .ourvendors_header__bjlKW .ourvendors_notifyme__FYBPm {
  position: absolute;
  display: flex;
  gap: 10;
  background: #C3D9FF;
  bottom: -65px;
  right: 30px;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Home/OurVendors/ourvendors.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,SAAA;AACJ;AACI;EACI,yDAAA;EACA,YAAA;EACA,aAAA;EAEA,eAAA;EACA,8BAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;AAAR;AAEQ;EACI,UAAA;EACA,YAAA;EACA,8BAAA;EACA,gCAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AAAZ;AAEY;EACI,qEAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAIA,kBAAA;AAHhB;;AAWA;EACI,YAAA;AARJ;AAUI;EACI,aAAA;EACA,sBAAA;EAEA,iBAAA;AATR;AAWQ;EACI,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;AATZ;AAWY;EACI,WAAA;EACA,YAAA;AAThB;AAYY;EACI,kBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,UAAA;AAVhB;AAaY;EACI,kBAAA;EACA,aAAA;EACA,OAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;AAXhB","sourcesContent":[".vendorCards {\n    display: flex;\n    gap: 10px;\n\n    .vendorCard {\n        background-image: url('../../../Assets/images/vendorbg.png');\n        width: 360px;\n        height: 200px;\n        // background: #05213D;\n        padding: 20px 0;\n        justify-content: space-between;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        border-radius: 20px;\n\n        .cashback {\n            width: 95%;\n            height: 36px;\n            background: rgba(255, 255, 255, 1);\n            border-radius: 14px 14px 4px 4px;\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            padding: 0 10px;\n\n            .africamap {\n                background: linear-gradient(310.98deg, #03297F 9.74%, #1656AF 90.51%);\n                width: 20px;\n                height: 20px;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                // top: 8px;\n                // left: 304px;\n                // gap: 0px;\n                border-radius: 3px;\n                // opacity: 0px;\n\n            }\n        }\n    }\n}\n\n.vendorDetails {\n    width: 600px;\n\n    header {\n        display: flex;\n        flex-direction: column;\n        // border: #03297F solid 1px;\n        min-height: 300px;\n\n        .header {\n            min-width: 100%;\n            min-height: 200px;\n            background-color: red;\n            position: relative;\n\n            .bgimg {\n                width: 100%;\n                height: 100%;\n            }\n\n            .vendorIcon {\n                position: absolute;\n                width: 96.64px;\n                height: 96.64px;\n                bottom: -70px;\n                left: 30px;\n            }\n\n            .notifyme {\n                position: absolute;\n                display: flex;\n                gap: 10;\n                background: #C3D9FF;\n                bottom: -65px;\n                right: 30px;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"vendorCards": `ourvendors_vendorCards__OtKP3`,
	"vendorCard": `ourvendors_vendorCard__AluKS`,
	"cashback": `ourvendors_cashback__i57ZA`,
	"africamap": `ourvendors_africamap__SJan6`,
	"vendorDetails": `ourvendors_vendorDetails__XsoKe`,
	"header": `ourvendors_header__bjlKW`,
	"bgimg": `ourvendors_bgimg__+Gsa+`,
	"vendorIcon": `ourvendors_vendorIcon__c0RCp`,
	"notifyme": `ourvendors_notifyme__FYBPm`
};
export default ___CSS_LOADER_EXPORT___;
